import { MenuSistemaEnum } from './core/enum/menu-sistema-enum';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AlertaComponent } from './components/alerta/alerta.component';
import { PreventBackButtonGuard } from './guards/prevent-back-button.guard';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },

  {
    path: 'login',
    component: LoginComponent,
    canActivate: [PreventBackButtonGuard],
  },
  {
    path: 'alertas',
    component: AlertaComponent,
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'tipo-usuario',
    loadChildren: () => import('./cadastro/perfil/perfil.module').then((m) => m.PerfilModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_TipoPerfil },
  },
  {
    path: 'administrador',
    loadChildren: () => import('./cadastro/administrador/administrador.module').then((m) => m.AdministradorModule),
  },
  {
    path: 'usuario',
    loadChildren: () => import('./cadastro/usuario/usuario.module').then((m) => m.UsuarioModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Usuarios },
  },
  {
    path: 'conta',
    loadChildren: () => import('./cadastro/conta/conta.module').then((m) => m.ContaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Contas },
  },
  {
    path: 'funcao',
    loadChildren: () => import('./cadastro/funcao/funcao.module').then((m) => m.FuncaoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Funcao },
  },
  {
    path: 'veiculos-mapa',
    loadChildren: () => import('./cadastro/veiculos-mapa/veiculos-mapa.module').then((m) => m.VeiculosMapaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_VeiculosMapa },
  },
  {
    path: 'parametro',
    loadChildren: () => import('./cadastro/parametros/parametros.module').then((m) => m.ParametrosModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_ParametrosSistema },
  },
  {
    path: 'entidade-publica',
    loadChildren: () =>
      import('./cadastro/entidade-publica/entidade-publica.module').then((m) => m.EntidadePublicaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_EntidadesPublicas },
  },
  {
    path: 'sistema-bilhetagem',
    loadChildren: () =>
      import('./cadastro/sistema-bilhetagem/sistema-bilhetagem.module').then((m) => m.SistemaBilhetagemModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_SistemaBilhetagem },
  },
  {
    path: 'empresas-transporte',
    loadChildren: () =>
      import('./cadastro/empresas-transporte/empresas-transporte.module').then((m) => m.EmpresasTransporteModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_EmpresaTransporte },
  },
  {
    path: 'cadastro-de-cedente',
    loadChildren: () =>
      import('./cadastro/cadastro-de-cedente/cadastro-de-cedente.module').then((m) => m.CadastroDeCedenteModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_CadastroCedente },
  },
  {
    path: 'comissoes-por-empresa',
    loadChildren: () =>
      import('./cadastro/comissoes-por-empresa/comissoes-por-empresa.module').then((m) => m.ComissoesPorEmpresaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_ComissoesPorEmpresa },
  },
  {
    path: 'veiculos',
    loadChildren: () => import('./cadastro/veiculos/veiculos.module').then((m) => m.VeiculosModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Veiculos },
  },
  {
    path: 'caixa-magica',
    loadChildren: () => import('./cadastro/caixa-magica/caixa-magica.module').then((m) => m.CaixaMagicaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_CaixaMagica },
  },
  {
    path: 'tarifa',
    loadChildren: () => import('./cadastro/tarifa/tarifa.module').then((m) => m.TarifaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_CodigoTarifario },
  },
  {
    path: 'ponto',
    loadChildren: () => import('./cadastro/ponto/ponto.module').then((m) => m.PontoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_PontoParada },
  },
  {
    path: 'linha',
    loadChildren: () => import('./cadastro/linha/linha-module').then((m) => m.LinhaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Linhas },
  },
  {
    path: 'grupo-linha',
    loadChildren: () => import('./cadastro/grupo-linha/grupo-linha.module').then((m) => m.GrupoLinhaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_GrupoLinhas },
  },
  {
    path: 'integracao',
    loadChildren: () => import('./cadastro/integracao/integracao.module').then((m) => m.IntegracaoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Integracao },
  },
  {
    path: 'beneficio',
    loadChildren: () => import('./cadastro/beneficio/beneficio.module').then((m) => m.BeneficioModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_BeneficiosConta },
  },
  {
    path: 'programacoes-viagens',
    loadChildren: () =>
      import('./cadastro/programacaoViagem/programacaoViagem.module').then((m) => m.ProgramacaoViagemModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_ProgramacaoViagens },
  },
  {
    path: 'programacoes-viagens-escalas',
    loadChildren: () =>
      import('./cadastro/programacao-viagem-escala/programacao-viagem-escala.module').then(
        (m) => m.ProgramacaoViagemEscalaModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Escala },
  },
  {
    path: 'loja',
    loadChildren: () => import('./cadastro/loja/loja.module').then((m) => m.LojaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Lojas },
  },
  {
    path: 'feriado',
    loadChildren: () =>
      import('./cadastro/calendario-operacional/calendario-operacional.module').then(
        (m) => m.CalendarioOperacionalModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_CalendarioOperacional },
  },
  // {
  //   path: 'beneficio-bilhetagem',
  //   loadChildren: () =>
  //     import('./cadastro/beneficio-bilhetagem/beneficio-bilhetagem.module').then((m) => m.BeneficioBilhetagemModule),
  // },
  {
    path: 'instituicao',
    loadChildren: () => import('./cadastro/instituicao/instituicao.module').then((m) => m.InstituicaoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_Instituicao },
  },
  /* {
        path: 'viagens',
        loadChildren: () => import('./cadastro/viagens/viagens.module').then(m => m.ViagemModule)
    }, */
  {
    path: 'atendente',
    loadChildren: () => import('./cadastro/atendente/atendente.module').then((m) => m.AtendenteModule),
  },
  {
    path: 'usuario-loja',
    loadChildren: () => import('./cadastro/usuario-loja/usuario-loja.module').then((m) => m.UsuarioLojaModule),
  },
  {
    path: 'tipo-documento',
    loadChildren: () => import('./cadastro/tipo-documento/tipo-documento.module').then((m) => m.TipoDocumentoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_CadastroTipoDocumento },
  },

  {
    path: 'exportacao-contabil',
    loadChildren: () =>
      import('./financeiro/exportacao-contabil/exportacao-contabil.module').then((m) => m.ExportacaoContabilModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_ExportacaoContabil },
  },

  {
    path: 'cadastro-rubricas',
    loadChildren: () =>
      import('./financeiro/cadastro-rubricas/cadastro-rubricas.module').then((m) => m.CadastroRubricasModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RubricasContabeis },
  },

  {
    path: 'subsidio',
    loadChildren: () =>
      import('./financeiro/subsidio-publico/subsidio-publico.module').then((m) => m.SubsidioPublicoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_SubsidioPublico },
  },
  {
    path: 'gestor',
    loadChildren: () => import('./cadastro/gestor/gestor.module').then((m) => m.GestorModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_AprovacaoEmpresaGestora },
  },
  {
    path: 'recarga',
    loadChildren: () => import('./cadastro/recarga/recarga.module').then((m) => m.RecargaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_AprovacaoSolicitacaoRecarga },
  },
  {
    path: 'debito-manual-similaridade',
    loadChildren: () =>
      import('./aprovacao/debito-manual-similaridade/debito-manual-similaridade.module').then(
        (m) => m.DebitoManualSimilaridadeModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_DecisaoManualFoto },
  },
  {
    path: 'registro-viagem',
    loadChildren: () => import('./aprovacao/registro-viagem.module').then((m) => m.RegistroViagemModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_AprovacaoRegistroViagem },
  },
  {
    path: 'operacao',
    loadChildren: () => import('./financeiro/operacao/operacao.module').then((m) => m.OperacaoModule),
  },
  {
    path: 'transacoes-financeiro',
    loadChildren: () => import('./financeiro/transacoes/transacoes.module').then((m) => m.TransacoesModule),
  },
  {
    path: 'fluxo',
    loadChildren: () => import('./financeiro/fluxo/fluxo-module').then((m) => m.FluxoModule),
  },
  {
    path: 'arrecadacao-rodoviario',
    loadChildren: () =>
      import('./relatorios/arrecadacao-rodoviario/arrecadacao-rodoviario.module').then(
        (m) => m.ArrecadacaoRodoviarioModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioArrecadacaoRodoviario },
  },
  {
    path: 'relatorio-conta',
    loadChildren: () =>
      import('./relatorios/relatorio-conta/relatorio-conta.module').then((m) => m.RelatorioContaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioContas },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./relatorios/dashboard/dashboard.module').then((m) => m.DashboardModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioDashBoard },
  },
  {
    path: 'relatorio-faixa-horaria',
    loadChildren: () =>
      import('./relatorios/relatorio-faixa-horaria/relatorio-faixa-horaria.module').then(
        (m) => m.RelatorioFaixaHorariaModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioFaixaHoraria },
  },
  {
    path: 'relatorio-faturamento-diario',
    loadChildren: () =>
      import('./relatorios/relatorio-faturamento-diario/relatorio-faturamento-diario.module').then(
        (m) => m.RelatorioFaturamentoDiarioModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioFaturamentoDiario },
  },
  {
    path: 'relatorio-faturamento-diario-analitico',
    loadChildren: () =>
      import('./relatorios/relatorio-faturamento-diario-analitico/relatorio-faturamento-diario-analitico.module').then(
        (m) => m.RelatorioFaturamentoDiarioAnaliticoModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioFaturamentoDiarioAnaliticoJasper },
  },
  {
    path: 'relatorio-fechamento-veiculo',
    loadChildren: () =>
      import('./relatorios/relatorio-fechamento-veiculo/relatorio-fechamento-veiculo.module').then(
        (m) => m.RelatorioFechamentoVeiculoModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioFechamentoVeiculo },
  },
  {
    path: 'relatorio-fechamento-veiculo-jasper',
    loadChildren: () =>
      import('./relatorios/relatorio-fechamento-veiculo-jasper/relatorio-fechamento-veiculo-jasper.module').then(
        (m) => m.RelatorioFechamentoVeiculoJasperModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioFechamentoVeiculoJasper },
  },
  {
    path: 'relatorio-recargas-realizadas',
    loadChildren: () =>
      import('./relatorios/relatorio-recargas-realizadas/relatorio-recargas-realizadas.module').then(
        (m) => m.RelatorioRecargasRealizadasModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioSinteticoRecargas },
  },
  {
    path: 'relatorio-utilizacao-vt',
    loadChildren: () => import('./relatorios/relatorio-utilizacao-vt/relatorio-utilizacao-vt.module').then((m) => m.RelatorioUtilizacaoVtModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_VtRelatorioUtilizacao },
  },
  {
    path: 'relatorio-por-empresa-vt',
    loadChildren: () => import("./relatorios/pedidos-por-empresa-vt/relatorio-pedidos-por-empresa-vt.module").then((m) => m.RelatorioPedidosPorEmpresaVtModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_VtPedidosEmpresas }
  },
  {
    path: 'realtorio-por-empresa-detalhe-vt',
    loadChildren: () => import("./relatorios/pedidos-por-empresa-detalhe-vt/relatorio-pedidos-por-empresa-detalhe-vt.module").then((m) => m.RelatorioPedidosPorEmpresaDetalheVtModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_VtPedidosEmpresasDetalhado }
  },
  {
    path: 'relatorio-aprovacao-manual-vt',
    loadChildren: () => import("./relatorios/aprovacao-manual-vt/relatorio-aprovacao-manual-vt.module").then((m) => m.RelatorioAprovacaoManualVtModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_VtAprovManual }
  },
  {
    path: 'relatorio-aprovacao-manual-detalhe-vt',
    loadChildren: () => import("./relatorios/aprovacao-manual-detalhe-vt/relatorio-aprovacao-manual-detalhe-vt.module").then((m) => m.RelatorioAprovacaoManualDetalheVtModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_VtAprovManualDetalhado }
  },
  {
    path: 'relatorio-qr-code-avulso',
    loadChildren: () => import("./relatorios/relatorio-qr-code-avulso/relatorio-qr-code-avulso.module").then((m) => m.RelatorioQrCodeAvulsoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioQRAvulsoJasper }
  },
  {
    path: 'relatorio-faturamento-diario-sintetico',
    loadChildren: () => import("./relatorios/relatorio-faturamento-diario-sintetico/relatorio-faturamento-diario-sintetico.module").then((m) => m.RelatorioFaturamentoDiarioSinteticoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioFaturamentoDiarioSinteticoJasper }
  },
  {
    path: 'taxa-empresa',
    loadChildren: () => import('./vt/taxa-empresa-vt/taxa-empresa-vt.module').then((m) => m.TaxaEmpresaVtModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_TaxaAdministrativa },
  },
  {
    path: 'relatorio-fechamento-loja',
    loadChildren: () => import("./relatorios/relatorio-fechamento-loja/relatorio-fechamento-loja.module").then((m) => m.RelatorioFechamentoLojaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioSinteticoDeVendasDaLoja }
  },
  {
    path: 'relatorio-prestacao-conta',
    loadChildren: () =>
      import('./relatorios/relatorio-prestacao-conta/relatorio-prestacao-conta.module').then(
        (m) => m.RelatorioPrestacaoContaModule
      ),
    data: { menuId: MenuSistemaEnum.C_Bilhetagem_RelatorioPrestacaoContas },
  },
  {
    path: 'relatorio-faturamento-mensal',
    loadChildren: () =>
      import('./relatorios/relatorio-faturamento-mensal/relatorio-faturamento-mensal.module').then(
        (m) => m.RelatorioFaturamentoMensalModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioFaturamentoMensal },
  },
  {
    path: 'relatorio-faturamento-linha',
    loadChildren: () =>
      import('./relatorios/relatorio-faturamento-linha/relatorio-faturamento-linha.module').then(
        (m) => m.RelatorioFaturamentoLinhaModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioUsoPorLinha },
  },
  {
    path: 'relatorio-utilizacao',
    loadChildren: () => import('./relatorios/utilizacao/utilizacao.module').then((m) => m.RelatorioUtilizacaoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioUtilizacao },
  },
  {
    path: 'relatorio-venda',
    loadChildren: () =>
      import('./relatorios/relatorio-venda/relatorio-venda.module').then((m) => m.RelatorioVendaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioVendasLojas },
  },
  {
    path: 'relatorio-vendas-pos',
    loadChildren: () =>
      import('./relatorios/relatorio-vendas-pos/relatorio-vendas-pos.module').then((m) => m.RelatorioVendasPosModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioVendasPOS },
  },
  {
    path: 'relatorio-venda-tiqueteira',
    loadChildren: () =>
      import('./relatorios/relatorio-venda-tiqueteira/relatorio-venda-tiqueteira.module').then(
        (m) => m.RelatorioVendaTiqueteiraModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioVendasTiqueteira },
  },
  {
    path: 'relatorio-viagem',
    loadChildren: () =>
      import('./relatorios/relatorio-viagem/relatorio-viagem.module').then((m) => m.RelatorioViagemModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioViagem },
  },
  {
    path: 'relatorio-historico-viagem',
    loadChildren: () =>
      import('./relatorios/historicoViagem/historicoViagens.module').then((m) => m.RelatorioHistoricoViagemModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioHistoricoViagem },
  },
  {
    path: 'relatorio-utilizacao-veiculo',
    loadChildren: () =>
      import('./relatorios/relatorio-utilizacao-veiculo/relatorio-utilizacao-veiculo.module').then(
        (m) => m.RelatorioUtilizacaoVeiculoModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioUtilizacaoVeiculo },
  },
  {
    path: 'relatorio-utilizacao-veiculo-jasper',
    loadChildren: () =>
      import('./relatorios/relatorio-utilizacao-veiculo-jasper/relatorio-utilizacao-veiculo-jasper.module').then(
        (m) => m.RelatorioUtilizacaoVeiculoJasperModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioUtilizacaoVeiculoJasper },
  },
  {
    path: 'conciliacao-de-viagens',
    loadChildren: () =>
      import('./pages/prestacao-contas/conciliacao-de-viagens/conciliacao-de-viagens.module').then(
        (m) => m.ConciliacaoDeViagensModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_ConciliacaoDeViagens },
  },
  {
    path: 'conciliacao-por-viagem',
    loadChildren: () =>
      import('./pages/prestacao-contas/conciliacao-por-viagem/conciliacao-por-viagem.module').then(
        (m) => m.ConciliacaoPorViagemModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_ConciliacaoPorViagem },
  },
  {
    path: 'conciliacao-em-lote',
    loadChildren: () =>
      import('./pages/prestacao-contas/conciliacao-em-lote/conciliacao-em-lote.module').then(
        (m) => m.ConciliacaoEmLoteModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_ConciliacaoPorLote },
  },
  {
    path: 'praca',
    loadChildren: () => import('./cadastro/praca/praca.module').then((m) => m.PracaModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_CadastroPraca },
  },
  {
    path: 'relatorio-liquidacao',
    loadChildren: () =>
      import('./relatorios/relatorio-liquidacao/relatorio-liquidacao.module').then((m) => m.RelatorioLiquidacaoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioLiquidacao },
  },
  // {
  //   path: 'perfil-acesso',
  //   loadChildren: () =>
  //     import('../../../Bilhetagem.FrontBilhetagem/src/app/cadastro/perfil-acesso/perfil-acesso.module').then(
  //       (m) => m.PerfilAcessoModule
  //     ),
  //   data: { menuId: MenuSistemaEnum.Bilhetagem_TipoPerfil },
  // },
  {
    path: 'cadastro-taxas',
    loadChildren: () =>
      import('./pages/contabilidade/cadastro-taxas/cadastro-taxas.module').then((m) => m.CadastroTaxasModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_CadastroTaxasAdquirente },
  },
  {
    path: 'relatorio-paygo-banrisul',
    loadChildren: () =>
      import('./pages/contabilidade/relatorio-paygo-banrisul/relatorio-paygo-banrisul.module').then(
        (m) => m.RelatorioPaygoBanrisulModule
      ),
  },
  {
    path: 'relatorio-banrisul-paygo',
    loadChildren: () =>
      import('./pages/contabilidade/relatorio-banrisul-paygo/relatorio-banrisul-paygo.module').then(
        (m) => m.RelatorioBanrisulPaygoModule
      ),
  },
  {
    path: 'relatorio-batimento',
    loadChildren: () =>
      import('./pages/contabilidade/relatorio-batimento/relatorio-batimento.module').then(
        (m) => m.RelatorioBatimentoModule
      ),
  },
  {
    path: 'upload-arquivo-banrisul',
    loadChildren: () =>
      import('./pages/contabilidade/arquivo-banrisul/arquivo-banrisul.module').then((m) => m.ArquivoBanrisulModule),
  },
  {
    path: 'relatorio-sintetico-banrisul',
    loadChildren: () =>
      import('./pages/contabilidade/relatorio-sintetico-banrisul/relatorio-sintetico-banrisul.module').then(
        (m) => m.RelatorioSinteticoBanrisulModule
      ),
  },
  {
    path: 'relatorio-liquidacao',
    loadChildren: () =>
      import('./relatorios/relatorio-liquidacao/relatorio-liquidacao.module').then((m) => m.RelatorioLiquidacaoModule),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioLiquidacao },
  },
  {
    path: 'relatorio-prestacao-conta',
    loadChildren: () =>
      import('./relatorios/relatorio-prestacao-conta/relatorio-prestacao-conta.module').then(
        (m) => m.RelatorioPrestacaoContaModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioPrestacaoContas },
  },
  {
    path: 'relatorio-vendas-qr-code',
    loadChildren: () => import('./relatorios/relatorio-vendas-qr-code/relatorio-vendas-qr-code.module').then(m => m.RelatorioVendasQrCode),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioQRAvulso }
  },
  {
    path: 'relatorio-recarga-analitico',
    loadChildren: () =>
      import('./relatorios/relatorio-recarga-analitico/relatorio-recarga-analitico.module').then(
        (m) => m.RelatorioRecargaAnaliticoModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioAnaliticoRecargas },
  },
  {
    path: 'transferencia-caixa-tem',
    loadChildren: () =>
      import('./cadastro/transferencia-caixa/transferencia-caixa.module').then((m) => m.TransferenciaCaixaModule),
  },
  {
    path: 'relatorio-utilizacao-beneficio',
    loadChildren: () =>
      import('./relatorios/relatorio-utilizacao-beneficio/relatorio-utilizacao-beneficio.module').then(
        (m) => m.RelatorioUtilizacaoBeneficioModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_RelatorioSolicitacaoBeneficio },
  },
  {
    path: 'pedidos',
    loadChildren: () =>
      import('./vt/recargas-realizadas-vt/recargas-realizadas-vt.module').then(
        (m) => m.RecargasRealizadasVtModule
      ),
    data: { menuId: MenuSistemaEnum.Bilhetagem_VtPedidos },
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
